import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { enviroment } from '../../environments/environment';
import { PostReqConnectionStatusCount } from '../models/request/post-req-connection-status-count.model';
import { GetResConnection } from '../models/response/get-res-conection.model';

@Injectable({
  providedIn: 'root',
})
export class ConnectionsService {
  httpOptions: {};
  apiUrl: string;

  constructor(private http: HttpClient) {
    this.httpOptions = {};
    this.apiUrl = `${enviroment.API_URL}/conexao`;
  }

  getConnection(id: string, accessAccountId: string, group: string): Observable<GetResConnection> {
    const url = `${this.apiUrl}/${id}/conta-acesso/${accessAccountId}/agrupador/${group}`;
    return this.http.get<GetResConnection>(url).pipe();
  }

  putConnection(id: string): Observable<void> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.put<void>(url, {}).pipe();
  }

  deleteConnection(id: string): Observable<void> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.delete<void>(url).pipe();
  }
}
